import React from "react";
import styled, { withTheme } from "styled-components";

const StyledContainer = styled.div`
  font-family: "Open Sans";
  padding: 0.09rem 0.93rem 0.09rem 0.93rem;
  line-height: 1.7rem;
  font-size: 0.8rem;
  cursor: pointer;
  border: 1px solid ${(props) => props?.theme?.white};
  &:hover {
    border: 1px solid ${(props) => props?.theme?.darkPurple};
  }

  &.active {
    color: ${(props) => props?.theme?.white};
    background-color: ${(props) => props?.theme?.darkPurple};
    border: 1px solid ${(props) => props?.theme?.darkPurple};
  }
`;

const DateSelectOption = (props) => {
  const {
    singleDay,
    daysFromToday,
    setEventDate,
    setStartDate,
    setEndDate,
    onOptionClick,
    className,
    children,
  } = props;

  const onClick = () => {
    const startingDate = new Date();

    startingDate.setDate(startingDate.getDate() - daysFromToday);
    startingDate.setHours(0, 0, 1);

    const tmpEndingDate = new Date();
    tmpEndingDate.setDate(tmpEndingDate.getDate() - 1);
    tmpEndingDate.setHours(0, 0, 1);

    const endingDate = singleDay ? startingDate : tmpEndingDate;

    if (setEventDate) {
      setEventDate(startingDate);
    }
    if (setStartDate) {
      setStartDate(startingDate);
    }

    if (setEndDate) {
      setEndDate(endingDate);
    }

    if (onOptionClick) {
      onOptionClick();
    }
  };

  return (
    <StyledContainer
      onClick={() => {
        onClick();
      }}
      className={className}
    >
      {children}
    </StyledContainer>
  );
};

export default withTheme(DateSelectOption);
